let uniqueId = 0;

export const getUniqueId = (prefix = "") => {
  uniqueId += 1;
  return prefix !== "" ? `${prefix}-${uniqueId}` : uniqueId.toString();
};
